import slsApi from "~/request/slsApi";

const uploadError = (key, description) => {
    const logDto = {
        operateType: '打包网页异常回传',
        keyAttr: key,
        description
    }
    return slsApi.logJsError(logDto)
}

export default {
    uploadError
}


// WEBPACK FOOTER //
// ./src/utils/errorUtils.js